import { render, staticRenderFns } from "./CopyPasswordPopup.vue?vue&type=template&id=32b38e67"
import script from "./CopyPasswordPopup.vue?vue&type=script&lang=ts"
export * from "./CopyPasswordPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports